module.exports = __webpack_public_path__ + "img/error_pay.4206cea0.png";